import { PaymentUtilService } from './../../services/payment-util/payment-util.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UtilService, VariablesService } from '../../../../shared/services';
import { ICart } from '../../models/cart.model';

@Component({
  selector: 'app-netbanking',
  templateUrl: './netbanking.component.html',
  styleUrls: ['./netbanking.component.scss']
})
export class NetbankingComponent implements OnInit {

  @Input() option;
  @Input() topBank;
  @Input() isOrderLoading;
  @Input() cartDetails: ICart;
  @Output() dataEmit: EventEmitter<any> = new EventEmitter();
  netBankForm: FormGroup;
  banksName: FormControl;

  searchForm: FormGroup;
  searchText: FormControl;
  bankList;

  constructor(
    private utilService: UtilService,
    public vars: VariablesService,
    public paymentUtilService: PaymentUtilService
  ) { }

  ngOnInit() {
    this.netBankForm = new FormGroup({
      banksName: this.banksName = new FormControl('', [Validators.required])
    });

    this.searchForm = new FormGroup({
      searchText: this.searchText = new FormControl(''),
    });
  }

  /**Get the keys of bank list object */
  getBankNames(data) {
    return data ? this.utilService.sortArray(Object.keys(data)) : null;
  }
  /**select the top bank from menu */
  selectTopBank(name) {
    this.banksName.setValue(name);
  }
  /**On click event of top banks */
  submitTopBank() {
    if (this.netBankForm.valid) {
      const data = {
        'mode': 'NB',
        'mode_value': this.banksName.value
      };
      this.dataEmit.emit(data);
    } else {
      this.utilService.checkValidForm(this.netBankForm);
    }
  }

  search(value) {
    if (!this.bankList) {
      this.bankList = this.option;
    }
    this.option = this.utilService.filterObject(this.bankList, value);
  }

  resetSearch() {
    this.search('');
    this.searchForm.controls['searchText'].setValue('');
  }
}
